import { Brick, registerBrick } from 'olympe';
import { getLogger } from '@olympeio/core';

export default class FormatDateTimeFromUTC extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Date} date
     * @param {function(string)} setDate
     */
    update($, [date], [setDate]) {
        if (!(date instanceof Date)) {
            getLogger('Format Datetime').error('datetime input is not a DateTime');
            return;
        }
        try {
            const formattedString = `${date.getUTCFullYear()}-${(date.getUTCMonth() + 1).toString().padStart(2, '0')}-${date.getUTCDate().toString().padStart(2, '0')}`;
            setDate(formattedString);
        } catch (e) {
            getLogger('Format Datetime').error(e);
        }
    }
}

registerBrick('018c15dc61ef87a71633', FormatDateTimeFromUTC);
